import { set as cookieSet, get as cookieGet } from "js-cookie";

/**
 * Key-Value-Store to LocalStorage with Fallback to Cookies
 */
export default class StorageBackend {
    private static storageSupported = typeof (Storage) !== "undefined";
    public static getValue(key: string): string {
        if (StorageBackend.storageSupported) {
            try {
                return localStorage.getItem(key);

            }
            catch (exception) {
                // something went wrong, probably private/incognito mode
                StorageBackend.storageSupported = false;
                return this.getValue(key);
            }
        } else {
            return cookieGet(key);
        }
    }

    public static setValue(key: string, value: string) {
        if (StorageBackend.storageSupported) {
            try {
                localStorage.setItem(key, value);
            } catch (exception) {
                // something went wrong, probably private/incognito mode
                StorageBackend.storageSupported = false;
                this.setValue(key, value);
            }
        } else {
            cookieSet(key, value);
        }
    }
}